import { useState, useEffect } from 'react'

export function useCountdown(initialSeconds: number = 3599) {
  const [timeLeft, setTimeLeft] = useState(initialSeconds)

  useEffect(() => {
    if (timeLeft <= 0) return

    const intervalId = setInterval(() => {
      setTimeLeft((prev) => prev - 1)
    }, 1000)

    return () => clearInterval(intervalId)
  }, [timeLeft])

  const hours = Math.floor(timeLeft / 3600)
    .toString()
    .padStart(2, '0')
  const minutes = Math.floor((timeLeft % 3600) / 60)
    .toString()
    .padStart(2, '0')
  const seconds = (timeLeft % 60).toString().padStart(2, '0')

  return { hours, minutes, seconds }
}
